/* Green Gorilla Fruits — newsletter
 * --------------------------------------------------------------
 * Submits the customer-form via fetch so the page does not reload.
 * The form remains a real <form> so JS-disabled clients fall back
 * to the standard POST + redirect.
 */
(function () {
  'use strict';

  async function onSubmit(e) {
    const wrapper = e.target.closest('[data-gg-newsletter-form]');
    if (!wrapper) return;
    const form = e.target.closest('form');
    if (!form || !wrapper.contains(form)) return;
    e.preventDefault();
    const success = wrapper.querySelector('[data-gg-newsletter-success]');
    const error = wrapper.querySelector('[data-gg-newsletter-error]');
    if (success) success.hidden = true;
    if (error) error.hidden = true;

    try {
      const formData = new FormData(form);
      const res = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) throw new Error('signup failed');
      if (success) {
        success.hidden = false;
      }
      form.reset();
    } catch (err) {
      if (error) {
        error.hidden = false;
      } else {
        // Fallback: let the browser submit the form normally.
        form.submit();
      }
    }
  }

  document.addEventListener('submit', onSubmit);
})();
